import { useState } from "react";
import { useNavigate } from "hooks/useCustomNavigation";
import { useShowSnackbar } from "hooks/useShowSnackbar";
import { useBrowserDeviceFingerprint } from "hooks/useBrowserDeviceFingerprint";
import { getCookie } from "services/cookies";
import { COOKIES } from "constants/cookies";
import { formatPhoneNumber } from "utils/strings";
import { INTERNAL_PATHS } from "routes/paths";
import { setUserToken } from "services/auth";
import { useAppContext } from "context/app-context";
import { signUp } from "./requests";
import { mapErrors } from "./mappers";
import { SUBMIT_ERROR_MESSAGE } from "./constant";

export const useSignUpSubmit = () => {
  const { getSessionInfo } = useAppContext();
  const { addNotification, removeNotification } = useShowSnackbar();
  const navigate = useNavigate();
  const { deviceFingerprint } = useBrowserDeviceFingerprint();
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState(null);

  const getSessionInfoAndNavigate = async ({ route, token }) => {
    await getSessionInfo(token);
    // wait for GuardRouter redirect first then navigate here
    setTimeout(() => {
      navigate(route);
    }, 100);
  };

  const handleSignUpResponse = async (response) => {
    const {
      data: { patch_token, verification_required }
    } = response;

    if (patch_token) {
      setUserToken({ token: patch_token });
    }

    if (verification_required) {
      await getSessionInfoAndNavigate({
        route: INTERNAL_PATHS.DEVICE_VERIFICATION_NEW,
        token: patch_token
      });
      return;
    }

    await getSessionInfoAndNavigate({
      route: INTERNAL_PATHS.HOME,
      token: patch_token
    });
  };

  const submitSignUp = async ({
    email,
    password,
    confirmPassword,
    phone,
    referralCode,
    captchaToken
  }) => {
    try {
      setIsLoading(true);
      removeNotification();
      const response = await signUp({
        captchaToken,
        XSession: getCookie(COOKIES.X_SESSION),
        fingerprint: deviceFingerprint,
        email,
        phone: formatPhoneNumber(phone),
        password,
        confirmPassword,
        ...(referralCode ? { referralCode: referralCode } : {})
      });
      await handleSignUpResponse(response);
    } catch (error) {
      const errorResponse = error.response.data;
      const hasErrors = !!errorResponse.errors?.length;
      if (hasErrors) {
        setErrors(mapErrors(errorResponse.errors));
      }
      addNotification({
        message: hasErrors ? SUBMIT_ERROR_MESSAGE : errorResponse.error,
        variant: "error",
        persist: true
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    errors,
    submitSignUp
  };
};
